module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_8011.b6309bcf.png";